import { ProfileTypes } from '../constants/ActionType';

export const LoginActionCreators = {
  userprofile: (data) => ({ type: ProfileTypes.USERPROFILE, payload: { data } }),
  updateuserprofile: (data) => ({ type: ProfileTypes.UPDATEUSERPROFILE, payload: { data } }),
  userprofiledata: (data) => ({ type: ProfileTypes.USERPROFILEDATA, payload: { data } })
}